/**
 * @fileoverview The SDK's own version, as a value the bundle can read.
 * @module lib/version
 *
 * `package.json` is not importable from a browser bundle without dragging a
 * JSON loader and the whole manifest into it, so the version is written here as
 * a literal — and `tests/sdk-version.test.ts` fails the build if this literal
 * ever drifts from `package.json`. A constant that can silently go stale is
 * worse than no constant, because `sdk_version` targeting would then hold a
 * feature back from users who already have the build.
 *
 * Bump this in the same commit as the `package.json` version.
 */
export const SDK_VERSION = '2.3.2';
